<template>
    <div v-if="popupFestival">
        <div class="fadein">
            <div class="popup-image" :class="(full) ? 'full' : '' ">
                <div class="guide-close-button floating-right">
                    <i class="fa fa-times-circle fa-2x" @click="closePopup"></i>
                </div>
                <div class="message">
                </div>
                <img :src="popupFestival.festival_popup.img" id="fadein1-img" style="cursor: pointer; height: 100%;">
            </div>
        </div>
    </div>
</template>
<script>
    import authCommon from '../mixins/authCommon'
    export default {
        mixins: [authCommon],
        data(){
            return{
                full:false
            }
        },
        methods:{
           
        },
        mounted() {
            if(this.popupFestival) {
                this.popupBreath()

                 let img = new Image();
                img.onload = () => {
                    if(window.innerHeight < img.height || window.innerWidth < img.width){
                        this.full = true
                    }else{
                        this.full = false
                    }
                    
                }

                img.src = this.popupFestival.festival_popup.img;
            }

           


        }
    }
</script>


// WEBPACK FOOTER //
// resources/mhg/vue/components/popup-festival.vue